
import EditorTipTap from "Editors/EditorTipTap";
export default {
  components: {
    EditorTipTap,
  },
  data() {
    return {
      inView: false,
      options: [
        {
          name: "image",
          label: "Image",
          type: "image",
        },
        {
          name: "link",
          label: "Poveznica",
          type: "link",
        },
      ],
    };
  },
};
